module.exports = {
  title: '圈子举报',
  route: {
    path: '/infomation-dynamic',
    children: {
      path: 'circle-report',
    },
  },
};
